import React from "react";
import "./styles.scss";


const RadioButton = (props) => <input className={'radio-button'} type="radio" {...props} />

export default RadioButton;
